import { FC, PropsWithChildren, useEffect } from 'react';
import { useTableStoreValue } from '../TableContext';

export type FilterOption = {
  id: number | string | boolean | null | (number | string | boolean)[];
  name: string;
};
export type FilterOptions = Record<string, FilterOption[]>;
export interface WithFilterOptionsProps {
  options?: FilterOptions;
}

export const WithFilterOptions: FC<
  PropsWithChildren & WithFilterOptionsProps
> = ({ children, options }) => {
  const [, setOptions] = useTableStoreValue('options');
  useEffect(() => {
    setOptions(options);
  }, [options, setOptions]);

  return children;
};
